(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('ContactFooter');
    if (!form) return;

    var HUBSPOT_URL =
      'https://api.hsforms.com/submissions/v3/integration/submit/243304379/8d3cdbbe-1216-4854-bf04-428b3d3f1044';
    var TIMEOUT_MS = 10000;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var emailInput = form.querySelector('input[type="email"]');
      var consentCheckbox = form.querySelector('input[type="checkbox"]');
      var submitBtn = form.querySelector('.newsletter-form__button--subscribe');
      var fieldWrapper = form.querySelector('.newsletter-form__field-wrapper');
      var consentLabel = form.querySelector('.footer__newsletter-consent');
      var honeypot = form.querySelector('input[name="website"]');

      if (!emailInput || !emailInput.value) return;
      if (consentCheckbox && !consentCheckbox.checked) {
        consentCheckbox.reportValidity();
        return;
      }
      if (honeypot && honeypot.value) return;

      submitBtn.disabled = true;
      submitBtn.classList.add('is-loading');

      var controller = new AbortController();
      var timeoutId = setTimeout(function () {
        controller.abort();
      }, TIMEOUT_MS);

      fetch(HUBSPOT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: controller.signal,
        body: JSON.stringify({
          fields: [{ objectTypeId: '0-1', name: 'email', value: emailInput.value }],
          context: { pageUri: window.location.href, pageName: document.title }
        })
      })
        .then(function (res) {
          clearTimeout(timeoutId);
          if (!res.ok) {
            return res.text().then(function (body) {
              console.error('HubSpot submission error:', res.status, body);
              throw new Error('HubSpot submission failed');
            });
          }

          if (fieldWrapper) fieldWrapper.style.display = 'none';
          if (consentLabel) consentLabel.style.display = 'none';

          var successMsg = document.createElement('h3');
          successMsg.className =
            'newsletter-form__message newsletter-form__message--success form__message';
          successMsg.setAttribute('tabindex', '-1');
          successMsg.textContent =
            "You're all set, sit back and we'll get the updates rolling!";
          form.appendChild(successMsg);
          successMsg.focus();
        })
        .catch(function (err) {
          clearTimeout(timeoutId);
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-loading');

          var existing = form.querySelector('.hs-error-msg');
          if (!existing) {
            var errorMsg = document.createElement('small');
            errorMsg.className = 'newsletter-form__message form__message hs-error-msg';
            errorMsg.textContent =
              err.name === 'AbortError'
                ? 'Request timed out. Please try again.'
                : 'Something went wrong. Please try again.';
            if (fieldWrapper) fieldWrapper.appendChild(errorMsg);
          }
        });
    });
  });
})();
